import { SMALL_CATEGORY_SLUG } from './category';

export const SUPPLEMENTS = 'supplements';
export const BRAND_ID = 'brandId';
export const FANCL = 'fancl';
export const SK2 = 'sk2';
export const CPB = 'cpb';
export const ANESSA = 'anessa';
export const ORBIS = 'orbis';
export const SUQQU = 'suqqu';
export const DHC = 'dhc';
export const INTEGRATE = 'integrate';
export const DEJAVU = 'dejavu';

export const POPULAR_BRANDS = [
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.CLEANSER,
    brandSlugs: [FANCL]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.FACE_WASH,
    brandSlugs: [SK2, CPB]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.FACE_LOTION,
    brandSlugs: [SK2]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.EMULSION,
    brandSlugs: [SK2]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.EYE_CREAM,
    brandSlugs: [SK2]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.ESSENCE,
    brandSlugs: [SK2]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.MASK_PACK,
    brandSlugs: [SK2]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.SUNSCREEN,
    brandSlugs: [ORBIS, DHC, FANCL, ANESSA]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.FACE_PRIMER,
    brandSlugs: [ORBIS, CPB]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.FOUNDATION,
    brandSlugs: [SUQQU, CPB, INTEGRATE]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.POWDER,
    brandSlugs: [CPB]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.EYES,
    brandSlugs: [SUQQU, DEJAVU, INTEGRATE]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.EYEBROWS,
    brandSlugs: [INTEGRATE]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.CHEEK,
    brandSlugs: [SUQQU]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.BEAUTY_SUPPLEMENTS,
    brandSlugs: [DHC]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.DIET_SUPPLEMENTS,
    brandSlugs: [DHC]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.HEALTH_SUPPLEMENTS,
    brandSlugs: [DHC]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.LIP_CARE,
    brandSlugs: [DHC, CPB]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.HIGH_LIGHTER,
    brandSlugs: [CPB]
  },
  {
    smallCategorySlug: SMALL_CATEGORY_SLUG.BREAST_MILK,
    brandSlugs: [CPB]
  }
];
